import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { ClientProps } from './Client.interface';
import { RowWrapper, MobileItem } from './Client.styles';

export function Client({ data, refresh }: ClientProps) {
    const {
        id,
        identifier,
        activeCampaigns,
        availableDovepoints,
        purchasedDovepoints
    } = data;
    return (
        <>
            {isMobile 
                ? 
                    <MobileItem>
                        <div>
                            <h3>Full name</h3>
                            <p><b>{identifier}</b></p>
                        </div>
                        <div></div>
                        <div>
                            <h3>DovePoints Available</h3>
                            <p>{availableDovepoints}</p>
                        </div>
                        <div>
                            <h3>DovePoints Purchased</h3>
                            <p>{purchasedDovepoints || '0'}</p>
                        </div>
                        <div>
                            <h3>Number of Active Campaigns</h3>
                            <p>{activeCampaigns}</p>
                        </div>
                    </MobileItem>
                :
                    <RowWrapper>
                        <p>{identifier}</p>
                        <p>{availableDovepoints}</p>
                        <p>{purchasedDovepoints || '0'}</p>
                        <p>{activeCampaigns}</p>
                    </RowWrapper>
            }
        </>
    )
}
